import Model from '../../../../model';
import { useCallback, useState } from 'react';
import { payTicket } from 'api/tickets';
import { payOrder } from 'api/orders';
import { toast } from 'react-hot-toast';

export const useOfficeOrderPayment = ({order}) => {

    const [ submitting, setSubmitting ] = useState(false);

    const { user: { balance } } = Model.user;
    const { openOfficePayOrderForm } = Model.modal;

    const ticketId = order.isTicket ? order.id : null;
    const orderId = order.isTicket ? null : order.id;
    const service = order.data.service.id;
    const visits = order.isTicket ? order.visits : 1;

    const pay = useCallback(() => {
        if (balance > 0) {
            openOfficePayOrderForm({orderId, ticketId, visits, service})
        } else {
            setSubmitting(true);
            const payPromise = order.isTicket ?
                payTicket({ticketId, service}) :
                payOrder({orderId, service});
            payPromise
                .then(({ redirect, error, errorMessage }) => {
                    if (redirect) {
                        window.location.href = redirect;
                    }
                    if (error) {
                        toast.error(errorMessage);
                    }
                    setSubmitting(false);
                }).catch((err) => {
                    toast.error(err);
                    setSubmitting(false);
                });
        }
    }, [order]);

    return {
        pay,
        disabled: submitting
    }
}
